import { GetRandomSalt } from "../helpers/Utils";

export default class ActionTrackerEntry {
  constructor(obj) {
    this.action = obj.action;
    this.payload = obj.payload;

    this.id = GetRandomSalt(24);
  }
}
